import * as classNames from 'classnames';
import { IActivityShort } from 'common/interfaces/activity';
import { IconButton } from 'components/action';
import { SavingIndicator, SavingIndicatorStatus } from 'components/indicator';
import { computed } from 'mobx';
import { observer } from 'mobx-react';
import * as moment from 'moment';
import * as React from 'react';
import { UserType } from 'common/interfaces/user';

// Styles
const s = require('./Activities.css');
const editIcon = require('assets/pen icon.svg');
const greenTickIcon = require('assets/tick green.svg');
const greyTickIcon = require('assets/tick dim.svg');

// Props
interface IActivityProps {
    onClick?: (activityId: number) => void;
    onMarkAsComplete?: (activityId: number) => void;
    onEdit?: (activityId: number) => void;
    loggedInUserId: number;
    loggedInUserType: UserType;
    activity: IActivityShort;
    isOnLeadPage?: boolean;
    now?: moment.Moment | null;
}

// Component
@observer
export class Activity extends React.Component<IActivityProps, {}> {
    static get defaultProps(): IActivityProps {
        return {
            onClick: null,
            onMarkAsComplete: null,
            onEdit: null,
            loggedInUserId: null,
            loggedInUserType: null,
            activity: null,
            isOnLeadPage: false,
            now: null,
        };
    }

    constructor(props: IActivityProps) {
        super(props);
    }

    @computed
    private get activityTimeFormatted(): string {
        const {
            activity: { time },
        } = this.props;

        return time === null
            ? ''
            : time.isSame(this.props.now, 'day')
            ? 'Today at ' + time.format('hh:mm A')
            : time.format('dddd, MMM Do, YYYY - hh:mm A');
    }

    @computed private get canActivityBeMarkesAsComplete(): boolean {
        if (!this.props.onMarkAsComplete) {
            return false;
        }

        if (this.props.activity.savingComplete) {
            return false;
        }

        if (this.props.loggedInUserId === null) {
            return false;
        }

        if (this.props.loggedInUserType !== UserType.SalesManager) {
            if (
                this.props.loggedInUserId !==
                this.props.activity.assignedToUser.id
            ) {
                return false;
            }
        }

        return true;
    }

    public render() {
        // Destructure
        const { activity, isOnLeadPage, loggedInUserId } = this.props;

        // Render
        return (
            <div
                onClick={this.handleActivityClick}
                className={classNames(s.activity, {
                    [s.activityWide]: this.props.isOnLeadPage,
                    [s.finished]: activity.finished,
                })}
            >
                <p className={s.activityTime}>
                    {this.props.now !== null &&
                        this.activityTimeFormatted !== '' && (
                            <strong>{this.activityTimeFormatted}</strong>
                        )}

                    <span>
                        {activity.time ? activity.time.format('A') : 'No date'}
                    </span>
                </p>

                <h4 className={s.activityTitle}>{activity.title}</h4>

                {activity.note && (
                    <p className={s.activityNote}>{activity.note}</p>
                )}

                {((isOnLeadPage === true && activity.author) ||
                    (isOnLeadPage === false && activity.provider)) && (
                    <p className={s.activityAuthorAndLead}>
                        {isOnLeadPage
                            ? activity.assignedToUser.name
                            : activity.provider.dba}
                    </p>
                )}

                {isOnLeadPage &&
                    !activity.finished &&
                    loggedInUserId !== null &&
                    activity.author.id === loggedInUserId &&
                    (typeof activity.savingComplete === 'undefined' ||
                        activity.savingComplete === false) &&
                    this.props.onEdit && (
                        <IconButton
                            className={s.editActivity}
                            onClick={this.handleActivityEdit}
                            icon={editIcon}
                            label="Edit activity"
                            showLabel={false}
                            labelOnRight={false}
                        />
                    )}

                {this.canActivityBeMarkesAsComplete && (
                    <IconButton
                        className={s.markAsComplete}
                        iconClassName={s.markAsCompleteIcon}
                        onClick={this.handleActivityMarkAsComplete}
                        icon={activity.finished ? greyTickIcon : greenTickIcon}
                        label={
                            activity.finished
                                ? 'Reopen activity'
                                : 'Mark as complete'
                        }
                        showLabel={isOnLeadPage ? true : false}
                        labelOnRight={false}
                    />
                )}

                <SavingIndicator
                    className={s.markingAsComplete}
                    labels={{ saving: 'Saving...' }}
                    status={
                        activity.savingComplete
                            ? SavingIndicatorStatus.Saving
                            : SavingIndicatorStatus.None
                    }
                />
            </div>
        );
    }

    private handleActivityClick = (e: React.MouseEvent<HTMLDivElement>) => {
        e.preventDefault();

        if (this.props.isOnLeadPage === false && this.props.onClick) {
            this.props.onClick(this.props.activity.id);
        }
    };

    private handleActivityEdit = (e: React.MouseEvent<HTMLButtonElement>) => {
        e.preventDefault();
        e.stopPropagation();

        if (this.props.onEdit) {
            this.props.onEdit(this.props.activity.id);
        }
    };

    private handleActivityMarkAsComplete = (
        e: React.MouseEvent<HTMLButtonElement>
    ) => {
        e.preventDefault();
        e.stopPropagation();

        if (this.props.onMarkAsComplete) {
            this.props.onMarkAsComplete(this.props.activity.id);
        }
    };
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--0!./app/web/src/components/activity/Activity.tsx